import * as React from 'react';
import type { SVGProps } from 'react';
const SvgArrowNarrowLeft = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      d="M20 12H4m0 0 6 6m-6-6 6-6"
    />
  </svg>
);
SvgArrowNarrowLeft.displayName = 'ArrowNarrowLeft';
export default SvgArrowNarrowLeft;
